import { Account } from '../../../../../@utils/normalizeAccount';

enum PERMISSION_CONTENT_TYPE {
    OUTER_URL = '0', // 外部链接
    COURSE = '1', // 课程
    PROGRAM = '2', // 学习项目
    CIRCLE = '3', // 学习圈
    SESSION = '4', // 小节
    LECTURER = '5', // 讲师
    MICRO_PAGES = '11', // 微页面
}
interface IPermissionContentProps {
    id: string;
    seId?: string;
    prefixCls?: string;
    showRefresh?: boolean;
    onRefresh?: () => void;
    normalizeAccountEPU?: (account: Account) => string;
    normalizeAccountName?: (account: Account) => string;
}
interface IPermissionContentInfo {
    content: (props: IPermissionContentProps) => JSX.Element;
}
type IPermissionContentMap = Record<PERMISSION_CONTENT_TYPE, IPermissionContentInfo>;
export { PERMISSION_CONTENT_TYPE, IPermissionContentMap, IPermissionContentProps, IPermissionContentInfo };
